/* Single item row in the feed cleaner review list. */

import { Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { ThumbnailPlaceholder } from "@/components/feed/ThumbnailPlaceholder";
import type { CleanerItem } from "@/types/feedCleaner";

interface CleanerItemRowProps {
  item: CleanerItem;
  isQueued: boolean;
  onToggle: () => void;
}

export function CleanerItemRow({ item, isQueued, onToggle }: CleanerItemRowProps) {
  return (
    <button
      className={`w-full text-left flex items-center gap-3 rounded-lg p-2.5 transition-colors ${
        isQueued
          ? "bg-primary/5 ring-1 ring-primary/20"
          : "opacity-60 hover:opacity-80 hover:bg-accent/50"
      }`}
      onClick={onToggle}
    >
      {/* Checkbox */}
      <div
        className={`size-5 shrink-0 rounded border-2 flex items-center justify-center transition-colors ${
          isQueued ? "bg-primary border-primary" : "border-muted-foreground/30"
        }`}
      >
        {isQueued && <Check className="size-3 text-primary-foreground" />}
      </div>

      {/* Thumbnail */}
      <div className="w-24 h-14 shrink-0 rounded-md overflow-hidden">
        {item.thumbnail ? (
          <img src={item.thumbnail} alt="" className="size-full object-cover" />
        ) : (
          <ThumbnailPlaceholder contentType={item.contentType} className="rounded-md" />
        )}
      </div>

      {/* Title + source */}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium leading-tight line-clamp-2">{item.title}</p>
        <p className="text-xs text-muted-foreground truncate mt-1">{item.sourceName}</p>
      </div>

      {/* Content type badge */}
      {item.contentType && (
        <Badge variant="secondary" className="text-xs px-2 py-0.5 shrink-0">
          {item.contentType}
        </Badge>
      )}
    </button>
  );
}
